import {Button, makeStyles} from "@material-ui/core";
import {useEffect} from "react";
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import {
  emptyUserMetrics,
  moveNextPage,
  updateUserAttributes,
  updateUserMetrics
} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import {initialUserMetrics} from "../../../../../store/reducers/creator/creatorExperienceBuilder";
import {useDispatch, useSelector} from "react-redux";
import roles from "../../../../../helper/roles";
import {updateCreatorOnboarding} from "../../../../../store/actions/creator/creatorOnBoarding";

const useStyles = makeStyles(() => ({
  title: {
    textAlign: 'center',
    fontSize: 36,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    lineHeight: 1.25,
    '@media (max-width: 600px)': {
      marginTop: 16,
      fontSize: '25px!important',
    },
  },
  description: {
    fontFamily: 'roboto-light',
    fontSize: 24,
    color: '#212D40',
    textAlign: 'center',
    lineHeight: 1.25,
    '@media (max-width: 600px)': {
      fontSize: 15,
    },
  },
  stepDescription: {
    fontFamily: 'roboto-light',
    fontSize: 18,
    color: '#212D40',
    lineHeight: 1.25,
    maxWidth: 310,
    '@media (max-width: 1150px)': {
      fontSize: 16,
    },
    '@media (max-width: 600px)': {
      fontSize: 12,
    },
  },
  btn: {
    fontFamily: 'roboto-regular',
    fontSize: 20,
    width: 280,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    marginTop: 40,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    '@media (max-width: 1150px)': {
      width: 200,
      height: 40,
      fontSize: 16,
    },
    '@media (max-width: 600px)': {
      marginTop: 10,
      marginBottom: 12,
      width: 'auto',
      height: 'auto',
      padding: '3px 12px',
      fontSize: 11,
    },
  },
  img: {
    width: 225,
    height: 180,
    margin: '30px 0',
    '@media (max-width: 1150px)': {
      width: 180,
    },
    '@media (max-width: 600px)': {
      width: 130,
      margin: 0
    },
  },
  container: {
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'space-around', 
    marginTop: 30,
    '@media (max-width: 750px)': {
      flexDirection: 'column'
    },
  }
}));

const Module4Finish = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm4s3');
  }, []);

  const initData = () => {
    const emptyRequest = {
      temporary_value: initialUserMetrics,
      user_id: loginUserData.user_id,
    };
    dispatch(updateUserAttributes(apolloClient.client, emptyRequest));
    dispatch(emptyUserMetrics());
  };

  const onFinishOnboarding = () => {
    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.creatoronboard.id,
      preference_name: 'CREATORONBOARD',
      preference_information: 'true'
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, request));
    localStorage.setItem('onboardingFinished', 'true');
  };

  const goCreateExperience = (pickVideo: boolean) => {
    onFinishOnboarding();
    initData();
    let url = `/creator/experience-builder`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['builder'])) {
      url = `/subscriber/creator/experience-builder`;
    }
    if (history) {
      if (history.location && history.location.state) {
        const historyState:any = history.location.state;
        if (historyState.prevPath && historyState.prevPath) {
          url = historyState.prevPath;
          historyState.prevPath = null
        }
      }
    }
    history.push(url);
    if (pickVideo) {
      setTimeout(() => {
        dispatch(moveNextPage(1));
        dispatch(updateUserMetrics('path', 1));
        dispatch(updateUserMetrics('content', 'ADVERTISING'));
        dispatch(updateUserMetrics('item', 'OTHER'));
      }, 1000)
    }
  };

  const goExperienceDashboard = () => {
    onFinishOnboarding();
    let url = `/creator/dashboard`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['dashboard'])) {
      url = `/subscriber/creator/dashboard`;
    }
    history.push(url);
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <div className={classes.title}>
        Congrats! You’ve completed Onboarding!
      </div>
      <div className={classes.description}>
        Some recommendations for next steps:
      </div>
      <div className={classes.container}>
        <div>
          <img className={classes.img} src={'/assets/icons/onboarding/module4-finish-1.svg'} alt={'Img1'} />
          <div className={classes.stepDescription}>
            If you’ve got a compatible smartwatch,
            create an experience and invite yourself
            to participate.
          </div>
          <Button color='primary' size='large' className={classes.btn} onClick={() => goCreateExperience(false)}>
            Measure Myself
          </Button>
        </div>

        <div>
          <img className={classes.img} src={'/assets/icons/onboarding/module4-finish-2.svg'} alt={'Img2'} />
          <div className={classes.stepDescription}>
            Pick a YouTube video or another video
            file and invite some friends with
            smartwatches to participate.
          </div>
          <Button color='primary' size='large' className={classes.btn} onClick={() => goCreateExperience(true)}>
            Measure Some Friends
          </Button>
        </div>

        <div>
          <img className={classes.img} src={'/assets/icons/onboarding/module4-finish-3.svg'} alt={'Img3'} />
          <div className={classes.stepDescription}>
            Check out some more sample
            measurement results in your
            Experience Dashboard.
          </div>
          <Button color='primary' size='large' className={classes.btn} onClick={goExperienceDashboard}>
            View More Results
          </Button>
        </div>
      </div>
    </div>
  )
};

export default Module4Finish;